import { createFileRoute } from "@tanstack/react-router"
import { AmphoraIntegration } from "modules/settings/components/integrations/amphora"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/amphora")({
  component: AmphoraIntegration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.amphora.title"),
    })
  },
})
